import DataTable, { createTheme } from 'react-data-table-component';
import React, { useMemo } from 'react';
import { Row, Col, Input, InputGroup, Button, Form, FormGroup, Label } from 'reactstrap';
import { Card, CardHeader, Alert, CardBody } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useSearchParams,useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOverallResult, downloadStandardCertificate, downloadStandardLetter, sendStandardCertificate, sendStandardLetter } from '../store/events/actions';
import { Circles } from "react-loader-spinner";
import { CSVLink, CSVDownload } from "react-csv";
import { red } from '@mui/material/colors';
import Dropdown from 'react-bootstrap/Dropdown';
import { useAuth } from '../hooks/useAuth';
import { getPostingDates } from '../store/postingDates/actions';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Overlay, Popover } from 'react-bootstrap';
import { getGroups,getBreedsInGroup } from '../helpers/backend_helper';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import ContentLoader from "react-content-loader";

export const GenerateCertificate = () => {
  const { user ,logout} = useAuth();

  const [filteredRankingList, setFilteredRankingList] = useState([]);
  var rankingForCSVAgilityHerding = [], rankingForCSV = [], rankingForCSVAgilityHerdingBreedWise = [], rankingForCSVAgilityHerdingGroupWise = [];
  const { overallRankingList, loadingGetOverallResult, certificateData, loadingDownloadCertificate, loadingSendCertificate, loadingDownloadLetter, letterId, loadingSendLetter } = useSelector((state) => state.EventsReducer);
  const [breedList, setBreedList] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [eventCat, setEventCat] = useState("Agility");
  const [breed_group, setBreedGroup] = useState("");
  const [allGroups, setAllGroups] = useState([]);
  const [newLoading, setNewLoading] = useState(true);
  const [downloadCerticatePayload,setDownloadCerticatePayload]=useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [iframeVisible, setIframeVisible] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState('');
  const [iframeKey, setIframeKey] = useState(0);
  const [currentCertificate, setCurrentCertificate] = useState([{}]);
  const [showPopover, setShowPopover] = useState(false);
  const [target, setTarget] = useState(null);
  const [letterIframeVisible, setLetterIframeVisible] = useState(false);
  const [letterUrl, setLetterUrl] = useState('');
  const [email, setEmail] = useState('');
  let new_ranking_list, filter_ranking_list;
  const { postingDatesList} = useSelector((state) => state.PostingDatesReducer);

  let dispatch = useDispatch();
  let allBreads = [];
  let allClasses = [];
  let postingDates=[];
  let beagleClasses = ["Females 13", "Females 15", "Males 13", "Males 15"];
  var no_of_export_breed_wise = 5;
  useEffect(() => {
    setNewLoading(true);
    setFilteredRankingList([]);
    const startEpoch = new Date("Jan 01," + year + " 00:00:00 GMT").getTime();
    const endEpoch = new Date("Dec 31," + year + " 00:00:00 GMT").getTime();
    dispatch(getOverallResult(eventCat + "&start_year=" + startEpoch + "&end_year=" + endEpoch));
    dispatch(getPostingDates(user?user.token:""));
  }, [year, eventCat]);

  useEffect(() => {
    getAllGroups();
  }, []);

  const getAllGroups = async () => {
    let response= await getGroups();
    setAllGroups(response.group_data);
  }
  
  useEffect(() => {
    setFilteredRankingList(calculateRank(overallRankingList));
    let breedsElement = document.getElementById("breeds");
    let groupsElement = document.getElementById("groups");
    let classElement = document.getElementById("classOrStake");

    groupsElement.value = "Select Group";
    if (breedsElement !== null)
      breedsElement.value = "All Breeds";
    if (classElement !== null)
      classElement.value = "All";
    setNewLoading(false);
    setBreedGroup("");
  }, [overallRankingList]);

  postingDates= postingDatesList.filter(obj => {
    //console.log('posting',obj);
    return obj.year === year;
  });

  useEffect(() => {
    //console.log("new group found");
    setFilteredRankingList(calculateRank(overallRankingList.filter((el) => {
      return breedList.some((f) => {
        return f.CKCBreedName === el.new_breed;
      });
    })));
  }, [breedList]);

  const navigate = useNavigate();
  const viewDogResult=(row)=>{
    navigate('/dog-result?dog_number='+row.dog_number);
  }

  useEffect(() => {
    if(downloadCerticatePayload?.isDownloading){
      let certificateTitle = '';
      switch (eventCat) {
        case "Agility":
          certificateTitle = "CKC TOP " + eventCat.toUpperCase() + " DOG";
          break;
        case "Beagle":
          certificateTitle = "CKC TOP FIELD BEAGLE";
          break;
        case "Herding":
          certificateTitle = "CKC TOP " + eventCat.toUpperCase() + " DOG";
          break;
        case "Lure Coursing":
          certificateTitle = "CKC TOP " + eventCat.toUpperCase() + " DOG";
          break;
        case "Pointing - Field Trial":
          certificateTitle = "CKC TOP POINTING DOG";
          break;
        case "Retriever Field Trial":
          certificateTitle = "CKC TOP RETRIEVING DOG";
          break;
        case "Spaniel Field Trial":
          certificateTitle = "CKC TOP FIELD SPANIEL";
          break;
        default:
          certificateTitle = "CKC TOP " + eventCat.toUpperCase() + " DOG";
          break;
      }
      const data = {
        eventType: eventCat,
        startYear: downloadCerticatePayload.startYear,
        breedGroup: breed_group,
        resultId: downloadCerticatePayload.resultId,
        ranking: downloadCerticatePayload.ranking,
        dogTitle: downloadCerticatePayload.dogTitle,
        dogName: downloadCerticatePayload.dogName,
        certificateTitle: certificateTitle,
        certificateId: downloadCerticatePayload.certificateId,
      }
      dispatch(downloadStandardCertificate(data, user.token));
      setCurrentCertificate([data]);
      setDownloadCerticatePayload({});
    }
  }, [downloadCerticatePayload?.isDownloading]);

  let generateCertificate = async (row)=>{
    // const date = new Date(parseInt(row.start_year));
    // const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    // const options = { timeZone: "Asia/Kolkata", year: 'numeric' };
    // const certificateYear = utcDate.toLocaleDateString('en-US', options);
    // console.log('certificateYear', certificateYear);

    let certificateYear = '';
    if(row.start_date != ''){
      var date = new Date(row.start_date);
      certificateYear = date.getFullYear(); 
    }
    else{
      certificateYear = year;
    }
    console.log('certificateYear', certificateYear);

    const data = {
      startYear: certificateYear,
      resultId: row.result_id,
      ranking: row.new_rank,
      dogTitle: row.dog_title,
      dogName: row.dog_name,
      certificateId: '',
      certificateTitle: '',
      isDownloading:true
    }
    setDownloadCerticatePayload(data);
    setSelectedRow(row);
    setIframeVisible(true);
    setEmail('');
  }

  const onFormChange = (key, value) => {
    currentCertificate[key] = value;
    setCurrentCertificate([currentCertificate]);
  }

  const updateCertificate = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const updatedCertificateData = {
      eventType: eventCat,
      breedGroup: breed_group,
      certificateTitle: data.get("certificateTitle"),
      dogTitle: data.get("dogTitle"),
      ranking: data.get("dogRank"),
      startYear: data.get("startYear"),
      certificateId: certificateData.certificateId
    }
    dispatch(downloadStandardCertificate(updatedCertificateData, user.token));
  };

  useEffect(() => {
    const appUrl = process.env.REACT_APP_APP_URL;
    const pdfUrl = appUrl+'getCertificate/';
    if (certificateData) {
      const url = pdfUrl + certificateData.certificateId;
      setCertificateUrl(url);
    }
    if(!loadingDownloadCertificate){
      setIframeKey((prevKey) => prevKey + 1);
    }
  }, [certificateData,loadingDownloadCertificate]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  //Send Certificate to Owner
  const sendCertificate = async (event) => {
    event.preventDefault();
    const certificateSendData = {
      email: email,
      certificateId: certificateData.certificateId
    }
    dispatch(sendStandardCertificate(certificateSendData, user.token));
  }

  //Send Letter to Owner
  const sendLetter = async (event) => {
    event.preventDefault();
    const letterData = {
      email: email,
      letterId: letterId
    }
    dispatch(sendStandardLetter(letterData, user.token));
  }

  const generateLetter = async (row)=>{
    const data = {
      resultId: row.result_id,
    }
    dispatch(downloadStandardLetter(data,user.token));
    setLetterIframeVisible(true);
    setEmail('');
  }

  useEffect(() => {
    const appUrl = process.env.REACT_APP_APP_URL;
    const pdfUrl = appUrl+'getLetter/';
    if (letterId) {
      const url = pdfUrl + letterId;
      setLetterUrl(url);
    }
    if(!loadingDownloadLetter){
      setIframeKey((prevKey) => prevKey + 1);
    }
  }, [letterId,loadingDownloadLetter]);

  //Close the Modal
  const closeModal = () => {
    setIframeVisible(false);
    setLetterIframeVisible(false);
  };

  const getBatchResults = async ()=>{
    console.log('batchYear',year);
    const data = {
      eventType: eventCat,
      eventYear: year,
      corResult: 0
    }

    // Convert the data object to a query string
    const queryString = Object.entries(data)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    // Construct the URL with the query string
    const url = `/batch-result?${queryString}`;

    // Open a new window with the constructed URL
    window.open(url, '_blank');
    //setShowPopover(!showPopover);
  }

  // const handleButtonClick = (event) => {
  //   setShowPopover(!showPopover);
  //   setTarget(event.target);
  // };

  const formatDogName = (row) => {
    let string = row.dog_title;
    let arrayOfString = string.includes(" ") ? string.split(" ") : [string];
    let characterLength = 0;
    let lineIndex = 0;
    let line = [];
    let totalValues = arrayOfString.length;
    let formattedText = '';
    if (totalValues > 1) {
      arrayOfString.forEach((value, key) => {
          let valCharLength = value.length + 1; // add 1 for the space after each word
          characterLength += valCharLength;
          
          if (characterLength <= 31) {
              line[lineIndex] = line[lineIndex] || [];
              line[lineIndex].push(value);
          } else {
              lineIndex++;
              if (key === totalValues - 1) { // if it's the last element in the array
                  line[lineIndex] = line[lineIndex] || [];
                  line[lineIndex].push(line[lineIndex - 1].pop()); // Get element from last line
                  line[lineIndex].push(value);
              } else {
                  line[lineIndex] = line[lineIndex] || [];
                  line[lineIndex].push(value);
              }
              characterLength = valCharLength; // reset character length for the new line
          }
      });

      // Join lines with <br> tag
      formattedText = line.map(line => line.join(' ')).join("\n");
    }
    else{
      formattedText = arrayOfString;
    }
    //console.log(formattedText);
    return formattedText;
  };

  allBreads = [...new Set(overallRankingList.map((item) => item.new_breed))];
  allClasses = [...new Set(overallRankingList.map((item) => item.class))];

  const columnsAgility = useMemo(() => [
    {
      name: 'Ranking',
      selector: row => row.new_rank,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: 'Dog Name & Breed',
      wrap: true,
      grow: 3,
      cell: row => (<Row>
        <p className='dog_name' style={{ whiteSpace: 'pre-wrap' }}>{formatDogName(row)}</p>
        <p className='breed_name'>{row.new_breed}</p>
      </Row>

      ),
    },
    {
      name: 'Owner Name',
      selector: row => row.owner_name,
      wrap: true,
      grow: 2
    },
    {
      name: 'Av. Score',
      selector: row => row.average_score,
      center: true,
      wrap: true,
    },
    {
      id: "totalPoints",
      name: 'Points',
      center: true,
      selector: row => row.total_points,
      wrap: true,
    },
    {
      name: 'Certificate',
      ignoreRowClick: true,
      grow:1,
      width:"100px",
      cell: row =>(
        <Row> 
          <Col sm="5"> 
            <Button title='Generate Certificate' color='primary' outline className='manage-event' onClick={() => generateCertificate(row)}>
              <CardMembershipIcon/>
            </Button>
          </Col>
        </Row>
      ),
    },
    // {
    //   name: 'Certificate',
    //   ignoreRowClick: true,
    //   grow:1,
    //   width:"100px",
    //   cell: row =>(
    //     <Row> 
    //       <Col sm="5"> 
    //         {( (breed_group !== '' && breed_group !== 'Select' && breed_group !== 'All Breeds') && row.new_rank <= 5) ? 
    //           ( 
    //             <Button title='Generate Certificate' color='primary' outline className='manage-event' onClick={() => generateCertificate(row)}>
    //               <ExitToAppIcon/>
    //             </Button>
    //           ) : 
    //           ( (breed_group === '' || breed_group === 'Select' || breed_group === 'All Breeds') && row.new_rank <= 10) ? (
    //             <Button title='Generate Certificate' color='primary' outline className='manage-event' onClick={() => generateCertificate(row)}>
    //               <ExitToAppIcon/>
    //             </Button>
    //           ) : ('')
    //         }
    //       </Col>
    //     </Row>
    //   ),
    // },
    {
      name: 'Letter',
      ignoreRowClick: true,
      grow:1,
      width:"150px",
      cell: row =>(
        <Row> 
          <Col sm="5"> 
            <Button title='Generate Letter' color='primary' outline className='manage-event' onClick={() => generateLetter(row)}>
              <StickyNote2Icon/>
            </Button>
          </Col>
        </Row>
      ),
    },
  ], []);

  const columnsBeagle = useMemo(() => [
    {
      name: 'Ranking',
      selector: row => row.new_rank,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: 'Dog Name & Breed',
      wrap: true,
      grow: 3,
      cell: row => (<Row>
        <p className='dog_name' style={{ whiteSpace: 'pre-wrap' }}>{formatDogName(row)}</p>
        <p className='breed_name'>{row.new_breed}</p>
      </Row>

      ),
    },
    {
      name: 'Class/Stake',
      selector: row => row.class,
      wrap: true,
      grow: 2
    },
    {
      name: 'Owner Name',
      selector: row => row.owner_name,
      wrap: true,
      grow: 2
    },


    {
      name: 'Qualif. Score',
      selector: row => row.no_of_trials,
      center: true,
      wrap: true,
    },
    {
      name: 'Points',
      center: true,
      selector: row => row.total_points,
      wrap: true,
    },
    {
      name: 'Certificate',
      ignoreRowClick: true,
      grow:1,
      width:"100px",
      cell: row =>(
        <Row> 
          <Col sm="10">   
            <Button title='Generate Certificate' color='primary' outline className='manage-event' onClick={()=>generateCertificate(row)}><CardMembershipIcon/></Button>
          </Col>
        </Row>
      ),
    },
    {
      name: 'Letter',
      ignoreRowClick: true,
      grow:1,
      width:"150px",
      cell: row =>(
        <Row> 
          <Col sm="5"> 
            <Button title='Generate Letter' color='primary' outline className='manage-event' onClick={() => generateLetter(row)}>
              <StickyNote2Icon/>
            </Button>
          </Col>
        </Row>
      ),
    },

  ], []);

  const columnsLureCoursing = useMemo(() => [

    {
      name: 'Ranking',
      selector: row => row.new_rank,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: 'Dog Name & Breed',
      wrap: true,
      grow: 3,
      cell: row => (<Row>
        <p className='dog_name' style={{ whiteSpace: 'pre-wrap' }}>{formatDogName(row)}</p>
        <p className='breed_name'>{row.new_breed}</p>
      </Row>

      ),
    },
    {
      name: 'Owner Name',
      selector: row => row.owner_name,
      wrap: true,
      grow: 2
    },

    {
      name: 'Qualif. Score',
      selector: row => row.no_of_trials,
      center: true,
      wrap: true,
    },
 
    {
      id: "totalPoints",
      name: 'Points',
      center: true,
      selector: row => row.total_points,
      wrap: true,
    },
    {
      name: 'Certificate',
      ignoreRowClick: true,
      grow:1,
      width:"100px",
      cell: row =>(
        <Row> 
          <Col sm="10"> 
            <Button title='Generate Certificate' color='primary' outline className='manage-event' onClick={() => generateCertificate(row)}>
              <CardMembershipIcon/>
            </Button>
          </Col>
        </Row>
      ),
    },
    {
      name: 'Letter',
      ignoreRowClick: true,
      grow:1,
      width:"150px",
      cell: row =>(
        <Row> 
          <Col sm="5"> 
            <Button title='Generate Letter' color='primary' outline className='manage-event' onClick={() => generateLetter(row)}>
              <StickyNote2Icon/>
            </Button>
          </Col>
        </Row>
      ),
    },

  ], []);

  function calculateRank(results_array) {
    // Sort the array based on score
    results_array.sort((a, b) => b.total_points - a.total_points);

    let rank = 1;
    let lastScore = null;

    // Assign a rank to each object based on its position in the sorted array
    results_array.forEach((item, index) => {
      if (item.total_points !== lastScore) {
        rank = index + 1;
      }
      item.new_rank = rank;
      lastScore = item.total_points;
    });
    return results_array;
  }

  function handleBreedChange(e) {
    //console.log(e.target.value);
    let element = document.getElementById("groups");
    element.value = "Select Group";
    console.log('breed', e.target.value);
    setBreedGroup(e.target.value);
    if (e.target.value === "All Breeds" || e.target.value === "Select") {

      setFilteredRankingList(calculateRank(overallRankingList));
    } else {
      setFilteredRankingList(calculateRank(overallRankingList.filter(obj => {
        return obj.new_breed === e.target.value;
      })));
    }

  }

  const handleGroupChange = async (e) => {
    //console.log(e.target.value);
    let breedsElement = document.getElementById("breeds");
    let classElement = document.getElementById("classOrStake");

    if (e.target.value === "Select Group") {
      if (breedsElement !== null)
        breedsElement.value = "All Breeds";
      if (classElement !== null)
        classElement.value = "All";
      setFilteredRankingList(calculateRank(overallRankingList));
      setBreedGroup("");
    } else {
      console.log('hello');
      if (breedsElement !== null)
        breedsElement.value = "Select";
      if (classElement !== null)
        classElement.value = "All";
 
      let response= await getBreedsInGroup(e.target.value);
      console.log("in res",response);
      setBreedList(response.breed_data);

      setBreedGroup("Group " + e.target.value);
      
    }
  }

  function handleClassChange(e) {
    console.log(e.target.value);
    let element = document.getElementById("groups");
    element.value = "Select Group";
    setBreedGroup(e.target.value);
    if (e.target.value === "All") {

      setFilteredRankingList(calculateRank(overallRankingList));
    } else {
      setFilteredRankingList(calculateRank(overallRankingList.filter(obj => {
        return obj.class === e.target.value;
      })));
    }

  }

  function getGroupName(breed_name) {
    let temp = allGroups.filter(obj => {
      return obj?.CKCBreedName?.toLowerCase() === breed_name?.toLowerCase();
    });
    if (temp.length > 0) {
      return temp[0].GroupName;
    } else {
      return "Unrecognized";
    }
  }
  if (overallRankingList.length > 0) {

    for (var i = 0; i < overallRankingList.length; i++) {
      let item = overallRankingList[i];
      if (item.rank > 10) {
        break;
      }
      let list = [{
        "Ranking": item.rank,
        "CKC Dog Number (Dog)": item.dog_number,
        "Name (Dog)": item.dog_name,
        "Dog Name with Title (Dog)": item.dog_title,
        "Breed (Dog)": item.new_breed,
        "Breed Size (Dog)": item.dog_breed_size,
        "Breed Variety (Dog)": item.dog_breed_variety,
        "CCN Breed (Dog)": item.ccn_breed,
        "Group": getGroupName(item.new_breed),
        "Number of qualifying scores": item.no_of_trials,
        "Average score": item.average_score,
        "Total points": item.total_points,
        "Full Name (Contact)": item.contact_data.name,
        "First Name (Contact)": item.contact_data.first_name,
        "Last Name (Contact)": item.contact_data.last_name,
        "CKC # (Contact)": item.contact_data.contact_number,
        "Email (Contact)": item.contact_data.email,
        "Address 1 (Contact)": item.contact_data.address,
        "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
        "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
        "Address 1: City (Contact)": item.contact_data.city,
        "Address 1: State/Province (Contact)": item.contact_data.area,
        "Address 1: Country (Contact)": item.contact_data.region,
        "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
      }];
      rankingForCSVAgilityHerding = rankingForCSVAgilityHerding.concat(list);
    }
    // rankingForCSVAgilityHerding = overallRankingList.slice(0, 10).map(item => ({
    //   "Ranking": item.rank,
    //   "CKC Dog Number (Dog)": item.dog_number,
    //   "Name (Dog)": item.dog_name,
    //   "Dog Name with Title (Dog)": item.dog_title,
    //   "Breed (Dog)": item.new_breed,
    //   "Breed Size (Dog)": item.dog_breed_size,
    //   "Breed Variety (Dog)": item.dog_breed_variety,
    //   "CCN Breed (Dog)": item.ccn_breed,
    //   "Group": getGroupName(item.new_breed),
    //   "Number of qualifying scores": item.no_of_trials,
    //   "Average score": item.average_score,
    //   "Total points": item.total_points,
    //   "Full Name (Contact)": item.contact_data.name,
    //   "First Name (Contact)": item.contact_data.first_name,
    //   "Last Name (Contact)": item.contact_data.last_name,
    //   "CKC # (Contact)": item.contact_data.contact_number,
    //   "Email (Contact)": item.contact_data.email,
    //   "Address 1 (Contact)": item.contact_data.address,
    //   "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
    //   "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
    //   "Address 1: City (Contact)": item.contact_data.city,
    //   "Address 1: State/Province (Contact)": item.contact_data.area,
    //   "Address 1: Country (Contact)": item.contact_data.region,
    //   "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
    // }));
    //console.log(rankingForCSVAgilityHerding);


    for (var i = 0; i < allBreads.sort().length; i++) {
      let tempList = calculateRank(overallRankingList.filter(obj => {
        return obj.new_breed === allBreads[i];
      }));

      rankingForCSVAgilityHerdingBreedWise = rankingForCSVAgilityHerdingBreedWise.concat([{
        "Breed": allBreads[i],
        "Ranking": "",
        "CKC Dog Number (Dog)": "",
        "Name (Dog)": "",
        "Dog Name with Title (Dog)": "",
        "Breed (Dog)": "",
        "Breed Size (Dog)": "",
        "Breed Variety (Dog)": "",
        "CCN Breed (Dog)": "",
        "Group": "",
        "Number of qualifying scores": "",
        "Average score": "",
        "Total points": "",
        "Full Name (Contact)": "",
        "First Name (Contact)": "",
        "Last Name (Contact)": "",
        "CKC # (Contact)": "",
        "Email (Contact)": "",
        "Address 1 (Contact)": "",
        "Address 1: Street 1 (Contact)": "",
        "Address 1: Street 2 (Contact)": "",
        "Address 1: City (Contact)": "",
        "Address 1: State/Province (Contact)": "",
        "Address 1: Country (Contact)": "",
        "Address 1: Zip/Postal Code (Contact)": "",
      }]);

      if (eventCat === "Lure Coursing" || eventCat === "Herding") {
        no_of_export_breed_wise = 10;

      } else {
        no_of_export_breed_wise = 5;
      }
      for (var j = 0; j < tempList.length; j++) {
        let item = tempList[j];
        if (item.new_rank > no_of_export_breed_wise) {
          break;
        }
        let breedRankingList = [{
          "Breed": "",
          "Ranking": item.new_rank,
          "CKC Dog Number (Dog)": item.dog_number,
          "Name (Dog)": item.dog_name,
          "Dog Name with Title (Dog)": item.dog_title,
          "Breed (Dog)": item.new_breed,
          "Breed Size (Dog)": item.dog_breed_size,
          "Breed Variety (Dog)": item.dog_breed_variety,
          "CCN Breed (Dog)": item.ccn_breed,
          "Group": getGroupName(item.new_breed),
          "Number of qualifying scores": item.no_of_trials,
          "Average score": item.average_score,
          "Total points": item.total_points,
          "Full Name (Contact)": item.contact_data.name,
          "First Name (Contact)": item.contact_data.first_name,
          "Last Name (Contact)": item.contact_data.last_name,
          "CKC # (Contact)": item.contact_data.contact_number,
          "Email (Contact)": item.contact_data.email,
          "Address 1 (Contact)": item.contact_data.address,
          "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
          "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
          "Address 1: City (Contact)": item.contact_data.city,
          "Address 1: State/Province (Contact)": item.contact_data.area,
          "Address 1: Country (Contact)": item.contact_data.region,
          "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
        }];
        rankingForCSVAgilityHerdingBreedWise = rankingForCSVAgilityHerdingBreedWise.concat(breedRankingList);

      }
      // let breedRankingList = tempList.slice(0, 5).map(item => ({
      //   "Breed": "",
      //   "Ranking": item.new_rank,
      //   "CKC Dog Number (Dog)": item.dog_number,
      //   "Name (Dog)": item.dog_name,
      //   "Dog Name with Title (Dog)": item.dog_title,
      //   "Breed (Dog)": item.new_breed,
      //   "Breed Size (Dog)": item.dog_breed_size,
      //   "Breed Variety (Dog)": item.dog_breed_variety,
      //   "CCN Breed (Dog)": item.ccn_breed,
      //   "Group": getGroupName(item.new_breed),
      //   "Number of qualifying scores": item.no_of_trials,
      //   "Average score": item.average_score,
      //   "Total points": item.total_points,
      //   "Full Name (Contact)": item.contact_data.name,
      //   "First Name (Contact)": item.contact_data.first_name,
      //   "Last Name (Contact)": item.contact_data.last_name,
      //   "CKC # (Contact)": item.contact_data.contact_number,
      //   "Email (Contact)": item.contact_data.email,
      //   "Address 1 (Contact)": item.contact_data.address,
      //   "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
      //   "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
      //   "Address 1: City (Contact)": item.contact_data.city,
      //   "Address 1: State/Province (Contact)": item.contact_data.area,
      //   "Address 1: Country (Contact)": item.contact_data.region,
      //   "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
      // }));

      // rankingForCSVAgilityHerdingBreedWise = rankingForCSVAgilityHerdingBreedWise.concat(breedRankingList);

    }
    //console.log(rankingForCSVAgilityHerdingBreedWise);

    //console.log("all classes", allClasses);



    // rankingForCSV = filteredRankingList.slice(0, 10).map(item => ({
    //   "Ranking": item.new_rank,
    //   "CKC Dog Number (Dog)": item.dog_number,
    //   "Name (Dog)": item.dog_name,
    //   "Dog Name with Title (Dog)": item.dog_title,
    //   "Breed (Dog)": item.new_breed,
    //   "Group": getGroupName(item.new_breed),
    //   "Total points": item.total_points,
    //   "Full Name (Contact)": item.contact_data.name,
    //   "First Name (Contact)": item.contact_data.first_name,
    //   "Last Name (Contact)": item.contact_data.last_name,
    //   "CKC # (Contact)": item.contact_data.contact_number,
    //   "Email (Contact)": item.contact_data.email,
    //   "Address 1 (Contact)": item.contact_data.address,
    //   "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
    //   "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
    //   "Address 1: City (Contact)": item.contact_data.city,
    //   "Address 1: State/Province (Contact)": item.contact_data.area,
    //   "Address 1: Country (Contact)": item.contact_data.region,
    //   "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
    // }));
  }

  if (allGroups.length > 0) {
    for (var i = 1; i < 8; i++) {

      let breedList = allGroups.filter(obj => {
        return obj.GroupName === "Group " + i;
      });

      let tempList = calculateRank(overallRankingList.filter((el) => {
        return breedList.some((f) => {
          return f.CKCBreedName === el.new_breed;
        });
      }));

      //  console.log("Group "+i,tempList);

      rankingForCSVAgilityHerdingGroupWise = rankingForCSVAgilityHerdingGroupWise.concat([{
        "Group": 'Group ' + i,
        "Ranking": "",
        "CKC Dog Number (Dog)": "",
        "Name (Dog)": "",
        "Dog Name with Title (Dog)": "",
        "Breed (Dog)": "",
        "Breed Size (Dog)": "",
        "Breed Variety (Dog)": "",
        "CCN Breed (Dog)": "",
        "Number of qualifying scores": "",
        "Average score": "",
        "Total points": "",
        "Full Name (Contact)": "",
        "First Name (Contact)": "",
        "Last Name (Contact)": "",
        "CKC # (Contact)": "",
        "Email (Contact)": "",
        "Address 1 (Contact)": "",
        "Address 1: Street 1 (Contact)": "",
        "Address 1: Street 2 (Contact)": "",
        "Address 1: City (Contact)": "",
        "Address 1: State/Province (Contact)": "",
        "Address 1: Country (Contact)": "",
        "Address 1: Zip/Postal Code (Contact)": "",
      }]);

      for (var j = 0; j < tempList.length; j++) {


        let item = tempList[j];
        if (item.new_rank > 10) {
          break;
        }

        let groupRankingList = [{
          "Group": "",
          "Ranking": item.new_rank,
          "CKC Dog Number (Dog)": item.dog_number,
          "Name (Dog)": item.dog_name,
          "Dog Name with Title (Dog)": item.dog_title,
          "Breed (Dog)": item.new_breed,
          "Breed Size (Dog)": item.dog_breed_size,
          "Breed Variety (Dog)": item.dog_breed_variety,
          "CCN Breed (Dog)": item.ccn_breed,
          "Number of qualifying scores": item.no_of_trials,
          "Average score": item.average_score,
          "Total points": item.total_points,
          "Full Name (Contact)": item.contact_data.name,
          "First Name (Contact)": item.contact_data.first_name,
          "Last Name (Contact)": item.contact_data.last_name,
          "CKC # (Contact)": item.contact_data.contact_number,
          "Email (Contact)": item.contact_data.email,
          "Address 1 (Contact)": item.contact_data.address,
          "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
          "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
          "Address 1: City (Contact)": item.contact_data.city,
          "Address 1: State/Province (Contact)": item.contact_data.area,
          "Address 1: Country (Contact)": item.contact_data.region,
          "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
        }];
        rankingForCSVAgilityHerdingGroupWise = rankingForCSVAgilityHerdingGroupWise.concat(groupRankingList);
      }
    }
  }

  if (allClasses.length > 0) {

    for (var i = 0; i < allClasses.sort().length; i++) {
      let tempList = calculateRank(overallRankingList.filter(obj => {
        return obj.class === allClasses[i];
      }));

      if (tempList.length > 0) {
        rankingForCSV = rankingForCSV.concat([{
          "Class": eventCat === "Beagle" ? beagleClasses[i] : allClasses[i],
          "Ranking": "",
          "CKC Dog Number (Dog)": "",
          "Name (Dog)": "",
          "Dog Name with Title (Dog)": "",
          "Breed (Dog)": "",
          "Group": "",
          "Total points": "",
          "Full Name (Contact)": "",
          "First Name (Contact)": "",
          "Last Name (Contact)": "",
          "CKC # (Contact)": "",
          "Email (Contact)": "",
          "Address 1 (Contact)": "",
          "Address 1: Street 1 (Contact)": "",
          "Address 1: Street 2 (Contact)": "",
          "Address 1: City (Contact)": "",
          "Address 1: State/Province (Contact)": "",
          "Address 1: Country (Contact)": "",
          "Address 1: Zip/Postal Code (Contact)": "",
        }]);

        for (var j = 0; j < tempList.length; j++) {
          let item = tempList[j];
          if (item.new_rank > 10) {
            break;
          }
          let classRankingList = [{
            "Class": "",
            "Ranking": item.new_rank,
            "CKC Dog Number (Dog)": item.dog_number,
            "Name (Dog)": item.dog_name,
            "Dog Name with Title (Dog)": item.dog_title,
            "Breed (Dog)": item.new_breed,
            "Group": getGroupName(item.new_breed),
            "Total points": item.total_points,
            "Full Name (Contact)": item.contact_data.name,
            "First Name (Contact)": item.contact_data.first_name,
            "Last Name (Contact)": item.contact_data.last_name,
            "CKC # (Contact)": item.contact_data.contact_number,
            "Email (Contact)": item.contact_data.email,
            "Address 1 (Contact)": item.contact_data.address,
            "Address 1: Street 1 (Contact)": item.contact_data.address_street_1,
            "Address 1: Street 2 (Contact)": item.contact_data.address_street_2,
            "Address 1: City (Contact)": item.contact_data.city,
            "Address 1: State/Province (Contact)": item.contact_data.area,
            "Address 1: Country (Contact)": item.contact_data.region,
            "Address 1: Zip/Postal Code (Contact)": item.contact_data.zip_code,
          }];
          rankingForCSV = rankingForCSV.concat(classRankingList);

        }
      }

    }
  }
  
  return (

    <div style={{ backgroundColor: '#F1F2F4' }}>
      <Modal isOpen={iframeVisible} toggle={() => setIframeVisible(false)} size="xl">
        <ModalHeader toggle={closeModal}>Certificate for Dog Show</ModalHeader>
        <ModalBody>
          <Row>
            <Col md="8">
              {loadingDownloadCertificate ? (
                <div className="loader">
                  <ContentLoader 
                    speed={1}
                    style={{ width: '100%', height: '100%' }}
                    viewBox="0 0 700 500"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#cecccc"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
                  </ContentLoader>
                </div>
              ) : (
              <iframe
                key={iframeKey}
                title="Certificate"
                src={certificateUrl}
                width="100%"
                height="600px"
                allowFullScreen
              ></iframe>
              )}
            </Col>
            <Col md="4">
              <div>
                <h5><ModeEditIcon/> Edit Certificate</h5>
                <hr></hr>
                <Form onSubmit={updateCertificate}>
                  <FormGroup row>
                    <Label for="certificateTitle" sm={4}> Certificate Title </Label>
                    <Col sm={7}>
                      <Input id="certificateTitle" name="certificateTitle" value={currentCertificate[0]?.certificateTitle} onChange={(e) => onFormChange(e.target.name, e.target.value)} placeholder="Enter Certificate Title" type="text" pattern="[^\d]+" title="Only letters are allowed" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="dogTitle" sm={4}> Dog Titles </Label>
                    <Col sm={7}>
                      <Input id="dogTitle" name="dogTitle" value={currentCertificate[0]?.dogTitle} onChange={(e) => onFormChange(e.target.name, e.target.value)} placeholder="Enter Dog Title" type="text" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="dogRank" sm={4}> Dog Rank </Label>
                    <Col sm={7}>
                      <Input id="dogRank" name="dogRank" value={currentCertificate[0]?.ranking} onChange={(e) => onFormChange(e.target.name, e.target.value)} placeholder="Enter Dog Rank" type="number" pattern="[0-9]*" title="Only numbers are allowed" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="startYear" sm={4}> Event Year </Label>
                    <Col sm={7}>
                      <Input id="startYear" name="startYear" value={currentCertificate[0]?.startYear} onChange={(e) => onFormChange(e.target.name, e.target.value)} placeholder="Enter Year" type="number" pattern="[0-9]*" title="Only numbers are allowed" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={{ offset: 4, size: 6}}>
                      <Button color='primary' outline type='submit'>
                        {loadingDownloadCertificate ? ('Please wait...') : ('Update')}
                      </Button>
                    </Col>
                  </FormGroup>
                </Form>
              </div>
              <hr></hr>
              <div>
                <Form onSubmit={sendCertificate}>
                  <FormGroup row>
                    <Label for="email" sm={4}> Enter Email</Label>
                    <Col sm={7}>
                      <Input id="email" name="email" placeholder="Enter Email" type="email" value={email} onChange={handleEmailChange} pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" title="Please enter a valid email address" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={{ offset: 4, size: 6}}>
                    <Button color='primary' className='marginRight' outline type='submit'>
                      {loadingSendCertificate ? ('Sending...') : ('Send Certificate')}
                    </Button>
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={letterIframeVisible} toggle={() => setLetterIframeVisible(false)} size="xl">
        <ModalHeader toggle={closeModal}>Letter</ModalHeader>
        <ModalBody>
          <Row>
            <Col md="8">
              {loadingDownloadLetter ? (
                <div className="loader" >
                  <ContentLoader 
                    speed={1}
                    style={{ width: '100%', height: '100%' }}
                    viewBox="0 0 700 500"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#cecccc"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
                  </ContentLoader>
                </div>
              ) : (
              <iframe
                key={iframeKey}
                title="Letter"
                src={letterUrl}
                width="100%"
                height="600px"
                allowFullScreen
              ></iframe>
              )}
            </Col>
            <Col md="4">
              <hr></hr>
              <div>
                <Form onSubmit={sendLetter}>
                  <FormGroup row>
                    <Label for="email" sm={4}> Enter Email</Label>
                    <Col sm={7}>
                      <Input id="email" name="email" placeholder="Enter Email" type="email" value={email} onChange={handleEmailChange} pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" title="Please enter a valid email address" required/>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                      <Col sm={{ offset: 4, size: 6}}>
                      <Button color='primary' className='marginRight' outline type='submit'>
                        {loadingSendLetter ? ('Sending...') : ('Send Letter')}
                      </Button>
                      </Col>
                  </FormGroup>
                </Form>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <div style={{ backgroundColor: '#F1F2F4' }}>
        <p className='page-heading'>All Certificates <nbsp/> 
          <span class="right-btn">
            <Button color="primary" onClick={getBatchResults}>Generate Batch
            </Button>
            {/* <Overlay show={showPopover} target={target} placement="left" rootClose onToggle={(newShow) => setShowPopover(newShow)}>
              <Popover id="popover-container">
                <Popover.Header as="h3">Select Batch Option</Popover.Header>
                <Popover.Body>
                  <Button color='primary' className='marginRight' outline onClick={()=>selectBatchOption('Top 10')}>
                      Top 10
                  </Button>
                  <Button color='primary' className='marginRight' outline onClick={()=>selectBatchOption('Top 5')}>
                      Top 5
                  </Button>
                </Popover.Body>
              </Popover>
            </Overlay> */}
          </span>
        </p>
      </div>
      <div className='page-body'>
        <Card className="my-2" style={{ padding: 0 }}>
          <CardHeader>
            <InputGroup sm={12}>
              <Col sm={3} className='marginRight'>
                <Input id="eventCat" name="eventCat" type="select" onChange={(e) => setEventCat(e.target.value)} required>
                  <option>Agility</option>
                  <option  value={"Beagle"}>Beagle Field Trial</option>
                  <option>Lure Coursing</option>
                  <option>Herding</option>
                  <option value={"Pointing - Field Trial"}>Pointing Field Trial</option>
                  <option>Retriever Field Trial</option>
                  <option>Spaniel Field Trial</option>
                  {/* <option>Sprinter</option> */}
                </Input>
              </Col>
              {/* <Col sm={2} className='marginRight'>
                <Input id="eventYear" name="eventYear" type="select" onChange={(e) => setYear(e.target.value)} required>
                  {eventCat!=="Spaniel Field Trial"?<option >2022</option>:""}
                  <option selected>2023</option>
                </Input>
              </Col> */}
              <Col sm={2} className='marginRight'>
                <Input id="eventYear" name="eventYear" type="select" onChange={(e) => setYear(e.target.value)} required>
                  {[...Array(3)].map((_, index) => {
                    const year = new Date().getFullYear() - index;
                    return <option key={year} selected={year.toString() === year ? "selected" : ""}>{year}</option>;
                  })}
                </Input>
              </Col>
              <Col sm={3} className='marginRight'>
                {eventCat === "Beagle" || eventCat === "Pointing - Field Trial" || eventCat === "Spaniel Field Trial"|| eventCat === "Retriever Field Trial"? eventCat === "Beagle" ? (
                <Input
                  sm={3}
                  id='classOrStake'
                  type='select'
                  name='classOrStake'
                  className=''
                  onChange={handleClassChange}
                  placeholder='Dog Class' >
                  <option selected>All</option>
                  <option>Males 15"</option>
                  <option>Females 15"</option>
                  <option>Males 13"</option>
                  <option>Females 13"</option>
                </Input>
                ) 
                : eventCat === "Retriever Field Trial" ? (
                  <Input
                    sm={3}
                    id='classOrStake'
                    type='select'
                    name='classOrStake'
                    className=''
                    onChange={handleClassChange}
                    placeholder='Dog Class' >
                    <option selected>All</option>
                    <option>Combined</option>
                    <option>Open All-Age</option>
                    <option>Amateur All-Age</option>
                    <option>Qualifying</option>
                    <option>Junior</option>

                  </Input>
                  )
                : eventCat === "Pointing - Field Trial" ? (
                  <Input
                    sm={3}
                    id='classOrStake'
                    type='select'
                    name='classOrStake'
                    className=''
                    onChange={handleClassChange}
                    placeholder='Dog Class' >
                    <option selected>All</option>
                    <option>Open Shooting Dog</option>
                    <option>Amateur Shooting Dog</option>
                    <option>Open Derby</option>
                    <option>Open Puppy</option>
                  </Input>
                  ) 
                  : (

                  <Input
                    sm={3}
                    id='classOrStake'
                    type='select'
                    name='classOrStake'
                    className=''
                    onChange={handleClassChange}
                    placeholder='Dog Class' >
                    <option selected>All</option>
                    <option>Open All-Age</option>
                    <option>Amateur All-Age</option>
                    <option>Puppy</option>
                    <option>Limited</option>
                  </Input>
                  )
                  :
                  (
                  <Input
                    sm={3}
                    id='breeds'
                    type='select'
                    name='breeds'
                    onChange={handleBreedChange}
                    placeholder='Dog Breed' >
                    <option>Select</option>
                    <option selected>All Breeds</option>
                    {allBreads.sort().map(function (item, i) {
                      return <option>{item}</option>
                    })}
                  </Input>
                  )}
                </Col>
                <Col sm={3} className='marginRight'>
                  <Input
                    sm={3}
                    id='groups'
                    type='select'
                    name='groups'
                    onChange={handleGroupChange}
                    placeholder='Dog Group' >
                    <option>Select Group</option>
                    <option value={1}>Group 1 - Sporting Group</option>
                    <option value={2}>Group 2 - Hound Group</option>
                    <option value={3}>Group 3 - Working Group</option>
                    <option value={4}>Group 4 - Terrier Group</option>
                    <option value={5}>Group 5 - Toy Group</option>
                    <option value={6}>Group 6 - Non-Sporting Group</option>
                    <option value={7}>Group 7 - Herding Group</option>
                  </Input>
                </Col>
                {/* {user?
                (eventCat === "Agility" || eventCat === "Herding" || eventCat === "Lure Coursing") ?
                  <Dropdown sm={3}>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      Export
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">
                        <CSVLink style={{ marginTop: '10px', color: red, fontSize: '17px', color: red }} data={rankingForCSVAgilityHerding} filename={eventCat + "_standings_" + year + "_all_breed"}>All Breeds</CSVLink>
                      </Dropdown.Item >
                      <Dropdown.Item href="#/action-2">
                        <CSVLink style={{ marginTop: '10px', color: red, fontSize: '17px', color: red }} data={rankingForCSVAgilityHerdingBreedWise} filename={eventCat + "_standings_" + year + "_breed_wise"}>Breed Wise</CSVLink>
                      </Dropdown.Item >
                      <Dropdown.Item href="#/action-3">
                        <CSVLink style={{ marginTop: '10px', color: red, fontSize: '17px', color: red }} data={rankingForCSVAgilityHerdingGroupWise} filename={eventCat + "_standings_" + year + "_group_wise"}>Group Wise</CSVLink>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  : <Button className='search-button' sm={4}>
                    <CSVLink style={{ marginTop: '10px', color: red, fontSize: '17px', color: red }} data={rankingForCSV} filename={eventCat + "_standings_" + year + "_class_wise"}>Export</CSVLink>
                  </Button>
                
                :("")} */}
              {/* <Button className='search-button' sm={4}><CSVLink style={{ marginTop: '10px', color: red, fontSize: '17px', color: red }} data={(eventCat === "Agility"||eventCat==="Herding") ?rankingForCSVAgilityHerding:rankingForCSV} filename={"standings_" + eventCat + year}>Export</CSVLink>
                </Button> */}
            </InputGroup>
          </CardHeader>
          <CardBody className='event-card-body'>
          {loadingGetOverallResult ? (
              <div className="loader" >
                 <ContentLoader 
                    speed={1}
                    width={'100%'}
                    height={(70 + 3) * 10 - 4} // Adjust the height based on the number of lines and gap
                    viewBox={`0 0 100% ${(70 + 4) * 10 - 4}`}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    {Array.from({ length: 10 }, (_, index) => (
                      <rect
                        key={index}
                        x="0"
                        y={(70 + 4) * index}
                        rx="5"
                        ry="5"
                        width="100%"
                        height="70"
                      />
                    ))}
                  </ContentLoader>
              </div>
            ) : (
            <DataTable
                columns={eventCat === "Beagle"||eventCat === "Pointing - Field Trial" ||eventCat === "Retriever Field Trial"||eventCat === "Spaniel Field Trial"? (columnsBeagle) : eventCat ==="Lure Coursing"? (columnsLureCoursing):(columnsAgility)}
                data={calculateRank(filteredRankingList)}
                filter
                theme=""
                pagination
                paginationRowsPerPageOptions={[50,100,200,300]}
                paginationPerPage={50}
                highlightOnHover
                defaultSortAsc={false}
                defaultSortFieldId={"totalPoints"}
              />
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default GenerateCertificate;
